<template>
  <!-- Added title="" here to block parent tooltips from bleeding into the sidebar area -->
  <section class="lg:relative absolute grid justify-center items-start place-content-center" title="">
    <div
      class="py-6 flex flex-col justify-start fixed bg-white shadow-sm rounded-lg gap-6 w-24 place-content-center justify-self-center"
      style="height: 93%" title="">
      
      <router-link title="" class="flex relative items-center w-full justify-center cursor-pointer"
        :to="'/organization/' + orgData.slug + '/home'">
        <img class="w-auto h-12 object-cover" :src="require('@/assets/images/new-sidebar/icon.svg')" />
      </router-link>

      <span class="w-auto bg-slate-100 mx-4 rounded-full xl:my-0 my-0" style="padding: 0.5px 0px"></span>

      <div class="flex relative items-center w-full justify-center flex-col xl:gap-6 gap-4">
        
        <!-- 1. Dashboard -->
        <vx-tooltip :text="$t('orgDashboard.sidebar.dashboard')" position="right" class="flex flex-col w-full">
          <router-link title="" :to="'/organization/' + orgData.slug + '/home'"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item"
            :class="activeRoute === 'org-home' ? 'sidebar__item__active' : ''">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="absolute __hover">
                <path d="M21.743 12.331L12.743 2.331C12.364 1.909 11.636 1.909 11.257 2.331L2.25698 12.331C2.12767 12.4747 2.04277 12.6527 2.01255 12.8436C1.98232 13.0345 2.00807 13.2301 2.08668 13.4067C2.16529 13.5833 2.29339 13.7333 2.45548 13.8386C2.61757 13.9439 2.8067 13.9999 2.99998 14H4.99998V21C4.99998 21.2652 5.10534 21.5196 5.29288 21.7071C5.48041 21.8946 5.73477 22 5.99998 22H18C18.2652 22 18.5196 21.8946 18.7071 21.7071C18.8946 21.5196 19 21.2652 19 21V14H21C21.1936 14.0008 21.3834 13.9453 21.546 13.8401C21.7087 13.735 21.8372 13.5848 21.916 13.4079C21.9947 13.231 22.0203 13.0349 21.9896 12.8437C21.9589 12.6525 21.8732 12.4744 21.743 12.331ZM12 16C11.2043 16 10.4413 15.6839 9.87866 15.1213C9.31605 14.5587 8.99998 13.7956 8.99998 13C8.99998 12.2043 9.31605 11.4413 9.87866 10.8787C10.4413 10.3161 11.2043 10 12 10C12.7956 10 13.5587 10.3161 14.1213 10.8787C14.6839 11.4413 15 12.2043 15 13C15 13.7956 14.6839 14.5587 14.1213 15.1213C13.5587 15.6839 12.7956 16 12 16Z" fill="#FBB603" />
                <rect x="5" y="10" width="14" height="7" fill="#FBB603" />
                <circle cx="12" cy="17" r="3" fill="#737171" />
              </svg>

              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="__regular">
                <path d="M21.7427 12.3311L12.7427 2.33115C12.3637 1.90915 11.6357 1.90915 11.2567 2.33115L2.25674 12.3311C2.12743 12.4748 2.04253 12.6529 2.0123 12.8438C1.98208 13.0347 2.00783 13.2303 2.08644 13.4068C2.16505 13.5834 2.29315 13.7334 2.45523 13.8387C2.61732 13.944 2.80645 14.0001 2.99974 14.0001H4.99974V21.0001C4.99974 21.2654 5.1051 21.5197 5.29263 21.7073C5.48017 21.8948 5.73452 22 5.99974 22H17.9997C18.265 22.0001 18.5193 21.8948 18.7068 21.7073C18.8944 21.5197 18.9997 21.2654 18.9997 21.0001V14.0001H20.9997C21.1934 14.001 21.3831 13.9454 21.5458 13.8403C21.7084 13.7352 21.837 13.585 21.9157 13.408C21.9945 13.2311 22.0201 13.0351 21.9894 12.8439C21.9586 12.6527 21.873 12.4745 21.7427 12.3311ZM11.9997 16.0001C11.2041 16.0001 10.441 15.6841 9.87842 15.1215C9.31581 14.5589 8.99974 13.7958 8.99974 13.0001C8.99974 12.2045 9.31581 11.4414 9.87842 10.8788C10.441 10.3162 11.2041 10.0001 11.9997 10.0001C12.7954 10.0001 13.5584 10.3162 14.1211 10.8788C14.6837 11.4414 14.9997 12.2045 14.9997 13.0001C14.9997 13.7958 14.6837 14.5589 14.1211 15.1215C13.5584 15.6841 12.7954 16.0001 11.9997 16.0001Z" fill="#737171" />
                <rect x="5" y="10" width="14" height="7" fill="#737171" />
                <circle cx="12" cy="17" r="3" fill="#FBB603" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.dashboard') }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" :src="require('@/assets/images/new-sidebar/arrow.svg')" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- 2. Role Design -->
        <vx-tooltip :text="'Organization Design'" position="right" class="flex flex-col w-full">
          <router-link title="" :to="'/organization/' + orgData.slug + '/roles'"
            :class="activeRoute === 'org-role-design' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute __hover">
                <path d="M9 19C9 18.2044 8.68393 17.4413 8.12132 16.8787C7.55871 16.3161 6.79565 16 6 16C5.20435 16 4.44129 16.3161 3.87868 16.8787C3.31607 17.4413 3 18.2044 3 19C3 19.7956 3.31607 20.5587 3.87868 21.1213C4.44129 21.6839 5.20435 22 6 22C6.79565 22 7.55871 21.6839 8.12132 21.1213C8.68393 20.5587 9 19.7956 9 19ZM9 5C9 4.20435 8.68393 3.44129 8.12132 2.87868C7.55871 2.31607 6.79565 2 6 2C5.20435 2 4.44129 2.31607 3.87868 2.87868C3.31607 3.44129 3 4.20435 3 5C3 5.79565 3.31607 6.55871 3.87868 7.12132C4.44129 7.68393 5.20435 8 6 8C6.79565 8 7.55871 7.68393 8.12132 7.12132C8.68393 6.55871 9 5.79565 9 5ZM6 8V16Z" fill="#FBB603" />
                <path d="M6 16C6.79565 16 7.55871 16.3161 8.12132 16.8787C8.68393 17.4413 9 18.2044 9 19C9 19.7956 8.68393 20.5587 8.12132 21.1213C7.55871 21.6839 6.79565 22 6 22C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19C3 18.2044 3.31607 17.4413 3.87868 16.8787C4.44129 16.3161 5.20435 16 6 16ZM6 16V8M6 8C5.20435 8 4.44129 7.68393 3.87868 7.12132C3.31607 6.55871 3 5.79565 3 5C3 4.20435 3.31607 3.44129 3.87868 2.87868C4.44129 2.31607 5.20435 2 6 2C6.79565 2 7.55871 2.31607 8.12132 2.87868C8.68393 3.44129 9 4.20435 9 5C9 5.79565 8.68393 6.55871 8.12132 7.12132C7.55871 7.68393 6.79565 8 6 8Z" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18 13.5853C18 12.6533 18 12.602 17.848 12.235C17.7475 11.9922 17.6001 11.7716 17.4143 11.5857C17.2284 11.3999 17.0078 11.2525 16.765 11.152C16.398 11 15.932 11 15 11H9C8.068 11 7.602 11 7.235 10.848C6.99218 10.7475 6.77155 10.6001 6.58572 10.4143C6.3999 10.2285 6.25251 10.0078 6.152 9.76501C6 9.39801 6 8.93201 6 8.00001" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.9998 16.5307V22M20.7344 19.2654H15.2651" stroke="#FBB603" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="__regular">
                <path d="M6 16C6.79565 16 7.55871 16.3161 8.12132 16.8787C8.68393 17.4413 9 18.2044 9 19C9 19.7956 8.68393 20.5587 8.12132 21.1213C7.55871 21.6839 6.79565 22 6 22C5.20435 22 4.44129 21.6839 3.87868 21.1213C3.31607 20.5587 3 19.7956 3 19C3 18.2044 3.31607 17.4413 3.87868 16.8787C4.44129 16.3161 5.20435 16 6 16ZM6 16V8M6 8C5.20435 8 4.44129 7.68393 3.87868 7.12132C3.31607 6.55871 3 5.79565 3 5C3 4.20435 3.31607 3.44129 3.87868 2.87868C4.44129 2.31607 5.20435 2 6 2C6.79565 2 7.55871 2.31607 8.12132 2.87868C8.68393 3.44129 9 4.20435 9 5C9 5.79565 8.68393 6.55871 8.12132 7.12132C7.55871 7.68393 6.79565 8 6 8Z" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M18 13.5853C18 12.6533 18 12.602 17.848 12.235C17.7475 11.9922 17.6001 11.7716 17.4143 11.5857C17.2284 11.3999 17.0078 11.2525 16.765 11.152C16.398 11 15.932 11 15 11H9C8.068 11 7.602 11 7.235 10.848C6.99218 10.7475 6.77155 10.6001 6.58572 10.4143C6.3999 10.2285 6.25251 10.0078 6.152 9.76501C6 9.39801 6 8.93201 6 8.00001" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M17.9998 16.5307V22M20.7344 19.2654H15.2651" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span class="text-base font-medium text-neutral-800 toggle">Role Design</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" :src="require('@/assets/images/new-sidebar/arrow.svg')" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- 3. Talent Pool -->
        <vx-tooltip :text="$t('orgDashboard.sidebar.talentPool')" position="right" class="flex flex-col w-full">
          <router-link title="" :to="'/organization/' + orgData.slug + '/talent'"
            :class="activeRoute === 'org-users' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              
              <!-- HOVER ICON (Yellow filled head, yellow plus, grey body) -->
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute __hover">
                  <!-- Body remains grey -->
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#737171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <!-- Head filled with yellow, with grey outline -->
                  <circle cx="8.5" cy="7" r="4" fill="#FBB603" stroke="#737171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></circle>
                  <!-- Plus sign changed to yellow -->
                  <line x1="20" y1="8" x2="20" y2="14" stroke="#FBB603" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
                  <line x1="23" y1="11" x2="17" y2="11" stroke="#FBB603" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
              </svg>
              
              <!-- NORMAL ICON (Full grey outline) -->
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="__regular">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" stroke="#737171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  <circle cx="8.5" cy="7" r="4" stroke="#737171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></circle>
                  <line x1="20" y1="8" x2="20" y2="14" stroke="#737171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
                  <line x1="23" y1="11" x2="17" y2="11" stroke="#737171" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></line>
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.talentPool') }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" :src="require('@/assets/images/new-sidebar/arrow.svg')" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- 4. Evaluation -->
        <vx-tooltip :text="$t('orgDashboard.sidebar.evaluation')" position="right" class="flex flex-col w-full">
          <router-link title="" :to="'/organization/' + orgData.slug + '/value'"
            :class="$route.path.includes('/value') ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <!-- Evaluation Hover State Icon -->
              <svg class="absolute __hover" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 19.5H11C8.172 19.5 6.757 19.5 5.879 18.621C5 17.743 5 16.328 5 13.5V7.5M14 19.5C14 20.2 12.006 21.509 11.5 22M14 19.5C14 18.8 12.006 17.491 11.5 17" stroke="#F8BE17" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 5C8 4.20435 7.68393 3.44129 7.12132 2.87868C6.55871 2.31607 5.79565 2 5 2C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5C2 5.79565 2.31607 6.55871 2.87868 7.12132C3.44129 7.68393 4.20435 8 5 8C5.79565 8 6.55871 7.68393 7.12132 7.12132C7.68393 6.55871 8 5.79565 8 5Z" fill="#FBB603" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 17V11C19 8.172 19 6.757 18.121 5.879C17.243 5 15.828 5 13 5H10M10 5C10 4.3 11.994 2.992 12.5 2.5M10 5C10 5.7 11.994 7.008 12.5 7.5" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 19C22 18.2044 21.6839 17.4413 21.1213 16.8787C20.5587 16.3161 19.7956 16 19 16C18.2044 16 17.4413 16.3161 16.8787 16.8787C16.3161 17.4413 16 18.2044 16 19C16 19.7956 16.3161 20.5587 16.8787 21.1213C17.4413 21.6839 18.2044 22 19 22C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19Z" fill="#FBB603" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <!-- Evaluation Default State Icon -->
              <svg class="__regular" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 19.5H11C8.172 19.5 6.757 19.5 5.879 18.621C5 17.743 5 16.328 5 13.5V8M14 19.5C14 20.2 12.006 21.509 11.5 22M14 19.5C14 18.8 12.006 17.491 11.5 17" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 5C8 4.20435 7.68393 3.44129 7.12132 2.87868C6.55871 2.31607 5.79565 2 5 2C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5C2 5.79565 2.31607 6.55871 2.87868 7.12132C3.44129 7.68393 4.20435 8 5 8C5.79565 8 6.55871 7.68393 7.12132 7.12132C7.68393 6.55871 8 5.79565 8 5Z" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 16V11C19 8.172 19 6.757 18.121 5.879C17.243 5 15.828 5 13 5H10M10 5C10 4.3 11.994 2.992 12.5 2.5M10 5C10 5.7 11.994 7.008 12.5 7.5" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M22 19C22 18.2044 21.6839 17.4413 21.1213 16.8787C20.5587 16.3161 19.7956 16 19 16C18.2044 16 17.4413 16.3161 16.8787 16.8787C16.3161 17.4413 16 18.2044 16 19C16 19.7956 16.3161 20.5587 16.8787 21.1213C17.4413 21.6839 18.2044 22 19 22C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19Z" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Evaluation</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" :src="require('@/assets/images/new-sidebar/arrow.svg')" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- 5. Recommendations -->
        <vx-tooltip :text="$t('orgDashboard.sidebar.plans')" position="right" class="flex flex-col w-full">
          <router-link title="" :to="'/organization/' + orgData.slug + '/plans'"
            :class="$route.path.includes('/plans') ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <!-- Recommendation Hover State Icon -->
              <svg class="absolute __hover" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 3.002C12.53 3.00067 12.03 3 11.5 3C7.022 3 4.782 3 3.391 4.391C2 5.782 2 8.021 2 12.5C2 16.978 2 19.218 3.391 20.609C4.782 22 7.021 22 11.5 22C15.978 22 18.218 22 19.609 20.609C21 19.218 21 16.979 21 12.5C21 11.97 20.9993 11.47 20.998 11" stroke="#737171" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M18.5 2L18.758 2.697C19.096 3.611 19.265 4.068 19.598 4.401C19.932 4.735 20.389 4.904 21.303 5.242L22 5.5L21.303 5.758C20.389 6.096 19.932 6.265 19.599 6.598C19.265 6.932 19.096 7.389 18.758 8.303L18.5 9L18.242 8.303C17.904 7.389 17.735 6.932 17.402 6.599C17.068 6.265 16.611 6.096 15.697 5.758L15 5.5L15.697 5.242C16.611 4.904 17.068 4.735 17.401 4.402C17.735 4.068 17.904 3.611 18.242 2.697L18.5 2Z" stroke="#F8BE17" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M7 17.5C9.332 15.058 13.643 14.943 16 17.5" stroke="#F8BE17" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M14.5 10C14.5 9.20435 14.1839 8.44129 13.6213 7.87868C13.0587 7.31607 12.2956 7 11.5 7C10.7044 7 9.94129 7.31607 9.37868 7.87868C8.81607 8.44129 8.5 9.20435 8.5 10C8.5 10.7956 8.81607 11.5587 9.37868 12.1213C9.94129 12.6839 10.7044 13 11.5 13C12.2956 13 13.0587 12.6839 13.6213 12.1213C14.1839 11.5587 14.5 10.7956 14.5 10Z" fill="#FBB603" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>

              <!-- Recommendation Default State Icon -->
              <svg class="__regular" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.5 10C14.5 9.20435 14.1839 8.44129 13.6213 7.87868C13.0587 7.31607 12.2956 7 11.5 7C10.7044 7 9.94129 7.31607 9.37868 7.87868C8.81607 8.44129 8.5 9.20435 8.5 10C8.5 10.7956 8.81607 11.5587 9.37868 12.1213C9.94129 12.6839 10.7044 13 11.5 13C12.2956 13 13.0587 12.6839 13.6213 12.1213C14.1839 11.5587 14.5 10.7956 14.5 10Z" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M13 3.002C12.53 3.00067 12.03 3 11.5 3C7.022 3 4.782 3 3.391 4.391C2 5.782 2 8.021 2 12.5C2 16.978 2 19.218 3.391 20.609C4.782 22 7.021 22 11.5 22C15.978 22 18.218 22 19.609 20.609C21 19.218 21 16.979 21 12.5C21 11.97 20.9993 11.47 20.998 11" stroke="#737171" stroke-width="1.5" stroke-linecap="round"/>
                <path d="M18.5 2L18.758 2.697C19.096 3.611 19.265 4.068 19.598 4.401C19.932 4.735 20.389 4.904 21.303 5.242L22 5.5L21.303 5.758C20.389 6.096 19.932 6.265 19.599 6.598C19.265 6.932 19.096 7.389 18.758 8.303L18.5 9L18.242 8.303C17.904 7.389 17.735 6.932 17.402 6.599C17.068 6.265 16.611 6.096 15.697 5.758L15 5.5L15.697 5.242C16.611 4.904 17.068 4.735 17.401 4.402C17.735 4.068 17.904 3.611 18.242 2.697L18.5 2Z" stroke="#737171" stroke-width="1.5" stroke-linejoin="round"/>
                <path d="M7 17.5C9.332 15.058 13.643 14.943 16 17.5" stroke="#737171" stroke-width="1.5" stroke-linecap="round"/>
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.recommendations') }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" :src="require('@/assets/images/new-sidebar/arrow.svg')" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- 6. Reports -->
        <vx-tooltip :text="$t('orgDashboard.sidebar.reports')" position="right" class="flex flex-col w-full">
          <router-link title="" :to="'/organization/' + orgData.slug + '/reports'"
            :class="activeRoute === 'org-reports' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute __hover">
                <path d="M9.99511 2.02103C7.49611 1.91603 5.56611 2.20303 5.56611 2.20303C4.34711 2.29103 2.01111 2.97303 2.01111 6.96503C2.01111 10.921 1.98611 15.799 2.01111 17.744C2.01111 18.932 2.74711 21.704 5.29311 21.852C8.38811 22.032 13.9631 22.071 16.5211 21.852C17.2051 21.813 19.4851 21.276 19.7731 18.796C20.0721 16.226 20.0131 14.441 20.0131 14.016" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M14.98 7.01605C14.98 7.01605 15.48 7.51605 15.98 8.51605C15.98 8.51605 17.569 6.01605 18.98 5.51605" stroke="#FBB603" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.97998 13.0161H10.98M6.97998 17.0161H14.98" stroke="#FBB603" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M16.9947 12.0161C19.7597 12.0161 21.9997 9.77705 21.9997 7.01605C21.9997 6.35902 21.8703 5.70844 21.6187 5.10148C21.3671 4.49453 20.9983 3.94311 20.5335 3.47875C20.0687 3.01439 19.5169 2.6462 18.9097 2.39522C18.3025 2.14424 17.6518 2.0154 16.9947 2.01605C14.2307 2.01605 11.9897 4.25405 11.9897 7.01605C11.9897 7.67308 12.1192 8.32367 12.3708 8.93063C12.6224 9.53758 12.9912 10.089 13.456 10.5534C13.9208 11.0177 14.4726 11.3859 15.0798 11.6369C15.687 11.8879 16.3377 12.0167 16.9947 12.0161Z" stroke="#FBB603" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="__regular">
                <path d="M14.9801 7.01603C14.9801 7.01603 15.4801 7.51603 15.9801 8.51603C15.9801 8.51603 17.5691 6.01602 18.9801 5.51602M9.99511 2.02103C7.49611 1.91603 5.56611 2.20303 5.56611 2.20303C4.34711 2.29103 2.01111 2.97303 2.01111 6.96503C2.01111 10.921 1.98611 15.799 2.01111 17.744C2.01111 18.932 2.74711 21.704 5.29311 21.852C8.38811 22.032 13.9631 22.071 16.5211 21.852C17.2051 21.813 19.4851 21.276 19.7731 18.796C20.0721 16.226 20.0131 14.441 20.0131 14.016" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                <path d="M6.97998 13.0161H10.98M6.97998 17.0161H14.98M22 7.01605C22 9.77705 19.76 12.0161 16.995 12.0161C16.338 12.0167 15.6872 11.8879 15.08 11.6369C14.4728 11.3859 13.921 11.0177 13.4562 10.5534C12.9914 10.089 12.6226 9.53758 12.3711 8.93063C12.1195 8.32367 11.99 7.67308 11.99 7.01605C11.99 4.25405 14.231 2.01605 16.995 2.01605C17.652 2.0154 18.3027 2.14424 18.9099 2.39522C19.5171 2.6462 20.0689 3.01439 20.5337 3.47875C20.9986 3.94311 21.3673 4.49453 21.6189 5.10148C21.8705 5.70844 22 6.35902 22 7.01605Z" stroke="#737171" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">{{ $t('orgDashboard.sidebar.reports') }}</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" :src="require('@/assets/images/new-sidebar/arrow.svg')" />
            </div>
          </router-link>
        </vx-tooltip>

        <!-- 7. Compensation -->
        <!-- <vx-tooltip :text="'Compensation'" position="right" class="flex flex-col w-full">
          <router-link title="" :to="'/organization/' + orgData.slug + '/compensation'"
            :class="$route.path.includes('/compensation') ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
            <svg
              class="absolute __hover"
              width="28"
              height="28"
              viewBox="0 0 150 148"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.5 77.5
                  C22.5 66 23.5 53 28.5 42
                  C36 25 52.5 10 72.5 8
                  C93 6 112.5 17 122 34
                  C127 43 128.5 53 127 63"
                stroke="#FBB603"
                stroke-width="7"
                stroke-linecap="round"
              />

              <path
                d="M76 24V82"
                stroke="#737171"
                stroke-width="6"
                stroke-linecap="round"
              />

              <path
                d="M91 35
                  C87 31 81 29 75 29
                  C67 29 61 33 61 39
                  C61 47 68 50 76 52
                  C84 54 91 57 91 65
                  C91 73 84 78 75 78
                  C68 78 62 75 58 71"
                stroke="#737171"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M15 108
                  L43 94
                  C46 92 50 92 54 94
                  L84 105
                  L119 91
                  C125 89 130 92 131 97
                  C132 101 130 105 126 107
                  L93 125
                  C87 129 80 131 73 130
                  L45 126
                  L31 137
                  C28 139 24 138 22 135
                  L14 115
                  C12 112 12 110 15 108Z"
                fill="white"
                stroke="#FBB603"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M45 95
                  L84 108
                  C89 110 94 108 96 104"
                stroke="#FBB603"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

            <svg
              class="__regular"
              width="28"
              height="28"
              viewBox="0 0 150 148"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26.5 77.5
                  C22.5 66 23.5 53 28.5 42
                  C36 25 52.5 10 72.5 8
                  C93 6 112.5 17 122 34
                  C127 43 128.5 53 127 63"
                stroke="#737171"
                stroke-width="7"
                stroke-linecap="round"
              />

              <path
                d="M76 24V82"
                stroke="#FBB603"
                stroke-width="6"
                stroke-linecap="round"
              />

              <path
                d="M91 35
                  C87 31 81 29 75 29
                  C67 29 61 33 61 39
                  C61 47 68 50 76 52
                  C84 54 91 57 91 65
                  C91 73 84 78 75 78
                  C68 78 62 75 58 71"
                stroke="#FBB603"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M15 108
                  L43 94
                  C46 92 50 92 54 94
                  L84 105
                  L119 91
                  C125 89 130 92 131 97
                  C132 101 130 105 126 107
                  L93 125
                  C87 129 80 131 73 130
                  L45 126
                  L31 137
                  C28 139 24 138 22 135
                  L14 115
                  C12 112 12 110 15 108Z"
                fill="white"
                stroke="#737171"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />

              <path
                d="M45 95
                  L84 108
                  C89 110 94 108 96 104"
                stroke="#737171"
                stroke-width="6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Compensation</span>
            </div>
            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" :src="require('@/assets/images/new-sidebar/arrow.svg')" />
            </div>
          </router-link>
        </vx-tooltip> -->

      </div>

      <div class="flex relative items-center w-full justify-end flex-col gap-2 h-full">
        <span class="w-full mx-4 rounded-full bg-slate-100" style="padding: 0.5px 0px"></span>
        <vx-tooltip :text="$t('orgDashboard.userDashboard.profileDropDown.settings') || 'Settings'" position="right" class="flex flex-col w-full">
          <router-link title="" :to="{ name: 'org-settings' }"
            :class="activeRoute === 'org-settings' ? 'sidebar__item__active' : ''"
            class="grid place-content-center justify-center grid-flow-col py-3 items-center relative overflow-hidden sidebar__item">
            <span class="absolute w-full h-full bg-primary rounded __hover" style="right: 95%"></span>

            <div class="flex justify-between items-center gap-3 w-fit">
              
              <!-- Hover State (Yellow Settings) -->
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="absolute __hover">
                <!-- Grey Inner Circle -->
                <circle cx="12" cy="12" r="3.5" fill="#737171" />
                <!-- Yellow Gear Parts -->
                <path d="M19.14 12.94C19.18 12.64 19.2 12.33 19.2 12C19.2 11.67 19.18 11.36 19.14 11.06L21.16 9.48C21.34 9.34 21.39 9.08 21.28 8.88L19.36 5.56C19.25 5.36 19 5.29 18.8 5.36L16.42 6.32C15.93 5.94 15.39 5.63 14.81 5.39L14.45 2.85C14.41 2.62 14.21 2.44 13.98 2.44H10.02C9.79 2.44 9.59 2.62 9.55 2.85L9.19 5.39C8.61 5.63 8.07 5.94 7.58 6.32L5.2 5.36C5 5.28 4.75 5.36 4.64 5.56L2.72 8.88C2.61 9.08 2.66 9.34 2.84 9.48L4.86 11.06C4.82 11.36 4.8 11.67 4.8 12C4.8 12.33 4.82 12.64 4.86 12.94L2.84 14.52C2.66 14.66 2.61 14.92 2.72 15.12L4.64 18.44C4.75 18.64 5 18.71 5.2 18.64L7.58 17.68C8.07 18.06 8.61 18.37 9.19 18.61L9.55 21.15C9.59 21.38 9.79 21.56 10.02 21.56H13.98C14.21 21.56 14.41 21.38 14.45 21.15L14.81 18.61C15.39 18.37 15.93 18.06 16.42 17.68L18.8 18.64C19 18.72 19.25 18.64 19.36 18.44L21.28 15.12C21.39 14.92 21.34 14.66 21.16 14.52L19.14 12.94ZM12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5Z" fill="#FBB603"/>
              </svg>

              <!-- Default State (Grey Gear, Yellow Circle) -->
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="__regular">
                <!-- Yellow Inner Circle -->
                <circle cx="12" cy="12" r="3.5" fill="#FBB603" />
                <!-- Grey Gear Parts -->
                <path d="M19.14 12.94C19.18 12.64 19.2 12.33 19.2 12C19.2 11.67 19.18 11.36 19.14 11.06L21.16 9.48C21.34 9.34 21.39 9.08 21.28 8.88L19.36 5.56C19.25 5.36 19 5.29 18.8 5.36L16.42 6.32C15.93 5.94 15.39 5.63 14.81 5.39L14.45 2.85C14.41 2.62 14.21 2.44 13.98 2.44H10.02C9.79 2.44 9.59 2.62 9.55 2.85L9.19 5.39C8.61 5.63 8.07 5.94 7.58 6.32L5.2 5.36C5 5.28 4.75 5.36 4.64 5.56L2.72 8.88C2.61 9.08 2.66 9.34 2.84 9.48L4.86 11.06C4.82 11.36 4.8 11.67 4.8 12C4.8 12.33 4.82 12.64 4.86 12.94L2.84 14.52C2.66 14.66 2.61 14.92 2.72 15.12L4.64 18.44C4.75 18.64 5 18.71 5.2 18.64L7.58 17.68C8.07 18.06 8.61 18.37 9.19 18.61L9.55 21.15C9.59 21.38 9.79 21.56 10.02 21.56H13.98C14.21 21.56 14.41 21.38 14.45 21.15L14.81 18.61C15.39 18.37 15.93 18.06 16.42 17.68L18.8 18.64C19 18.72 19.25 18.64 19.36 18.44L21.28 15.12C21.39 14.92 21.34 14.66 21.16 14.52L19.14 12.94ZM12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5Z" fill="#737171"/>
              </svg>

              <span class="text-base font-medium text-neutral-800 toggle">Settings</span>
            </div>

            <div class="rotate-90 opacity-30 toggle">
              <img class="w-3" :src="require('@/assets/images/new-sidebar/arrow.svg')" />
            </div>
          </router-link>
        </vx-tooltip>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "v-nav-menu",
  components: {},
  props: {},
  computed: {
    activeRoute() {
      return this.$route.name.toLowerCase();
    },
    orgData() {
      return this.$store.state.organization.orgData;
    },
  },
  created() {
  },
};
</script>

<style lang="scss">
/* Unified Sidebar Item styling */
.sidebar__item {
  cursor: pointer;

  .__hover {
    transition: opacity 0.2s ease-in-out;
    opacity: 0;
  }

  .__regular {
    transition: opacity 0.2s ease-in-out;
    opacity: 1;
  }
}

/* Hovered & Active States */
.sidebar__item:hover,
.sidebar__item__active {
  .__hover {
    opacity: 1;
  }
  .__regular {
    opacity: 0;
  }
}

.toggle {
  display: none;
}

.active path {
  stroke: #ffcc00 !important;
}
</style>